var React = require('react');

function IconHardshipAssistance (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M29.623 3.35c-4.318 4.5-13.01 7.337-23.25 7.58l-1.173.028-.245 1.159a136 136 0 00-2.259 15.3c-.622 6.767-1.128 19.133 2.488 25.9 2.695 5.046 11.024 9.948 14.48 11.823a98.804 98.804 0 0010.294 4.858l.542.214.541-.214a98.837 98.837 0 0010.294-4.859c3.456-1.874 11.785-6.776 14.481-11.822 3.616-6.77 3.11-19.133 2.488-25.9a136.004 136.004 0 00-2.26-15.305l-.244-1.158-1.171-.029C44.57 10.681 36.02 7.85 31.762 3.35l-1.067-1.125zm14.236 27.623h-7.89V23H25.03v7.973h-7.888v11.054h7.888V50h10.94v-7.973h7.89z","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3"}));
}

IconHardshipAssistance.defaultProps = {"height":"72","width":"61"};

module.exports = IconHardshipAssistance;

IconHardshipAssistance.default = IconHardshipAssistance;
